var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79799 1.09937V3.73265M18.0866 1.09937V3.73265M1.40918 19.5324V6.36593C1.40918 5.66754 1.68661 4.99776 2.18045 4.50392C2.67429 4.01008 3.34407 3.73265 4.04246 3.73265H19.8422C20.5406 3.73265 21.2103 4.01008 21.7042 4.50392C22.198 4.99776 22.4755 5.66754 22.4755 6.36593V19.5324M1.40918 19.5324C1.40918 20.2307 1.68661 20.9005 2.18045 21.3944C2.67429 21.8882 3.34407 22.1656 4.04246 22.1656H19.8422C20.5406 22.1656 21.2103 21.8882 21.7042 21.3944C22.198 20.9005 22.4755 20.2307 22.4755 19.5324M1.40918 19.5324V10.7547C1.40918 10.0563 1.68661 9.38656 2.18045 8.89273C2.67429 8.39889 3.34407 8.12146 4.04246 8.12146H19.8422C20.5406 8.12146 21.2103 8.39889 21.7042 8.89273C22.198 9.38656 22.4755 10.0563 22.4755 10.7547V19.5324M11.9423 12.5103H11.9517V12.5196H11.9423V12.5103ZM11.9423 15.1435H11.9517V15.1529H11.9423V15.1435ZM11.9423 17.7768H11.9517V17.7862H11.9423V17.7768ZM9.30903 15.1435H9.31839V15.1529H9.30903V15.1435ZM9.30903 17.7768H9.31839V17.7862H9.30903V17.7768ZM6.67575 15.1435H6.68511V15.1529H6.67575V15.1435ZM6.67575 17.7768H6.68511V17.7862H6.67575V17.7768ZM14.5756 12.5103H14.585V12.5196H14.5756V12.5103ZM14.5756 15.1435H14.585V15.1529H14.5756V15.1435ZM14.5756 17.7768H14.585V17.7862H14.5756V17.7768ZM17.2089 12.5103H17.2182V12.5196H17.2089V12.5103ZM17.2089 15.1435H17.2182V15.1529H17.2089V15.1435Z",
    stroke: "#6E6C6C",
    strokeWidth: 1.75552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/Booking.abf5342261c6d60ee61dde99300a3316.svg";
export { ForwardRef as ReactComponent };